import { composeClassNames } from "@faedev/editor-utils";
import { useRouter } from "next/router";
import { Button, Col, Row } from "react-bootstrap";
import Content from "src/components/Content";
import Footer from "src/components/Footer";
import Footers from "src/components/Footers";
import Header from "src/components/Header";
import Headers from "src/components/Headers";
import Page from "src/components/Page";
import SectionHeading from "src/components/SectionHeading";
import Translate from "src/components/Translate";
import constants from "src/constants";
import getDefaultOg from "src/functions/getDefaultOg";
import gutter from "src/functions/gutter";
import Small_chevron_right from "src/icons/Small-chevron-right";
import { sButton } from "src/styles/sButton.module.scss";
import { sButtons } from "src/styles/sButtons.module.scss";
import { sPage404 } from "src/styles/sPage404.module.scss";
import dynamic from "next/dynamic";

const LottieImage = dynamic(() => import("src/components/LottieImage"));

export default function Contacts() {
  const { locale: lang, push } = useRouter();

  return (
    <>
      <Headers data={getDefaultOg(lang)} />
      <Page className={composeClassNames([sPage404, "page-404"])}>
        <Header />
        <Content fluid={`xl`} verticalSpace="lg">
          <div style={gutter("margin", "top", "md")}>
            <LottieImage src="Lottie-coffe" width={300} height={300} />
          </div>
          <SectionHeading
            align="center"
            subtitle="The page has disappeared or never existed. But we have good news for you: you will definitely find something else that interests you."
            style={gutter("margin", "top", "md")}
            title="Here it is... The nothing"
          />
          <Row>
            <Col xs={12}>
              <div
                className={composeClassNames([
                  sButtons,
                  "row",
                  "align-center",
                  "buttons-404",
                ])}
              >
                <Button
                  className={composeClassNames([sButton, "btn-icon-after"])}
                  onClick={() => push(constants.Paths.landingPageMembers)}
                  variant="outline-primary"
                >
                  <Translate tKey="Service information" />
                  <Small_chevron_right />
                </Button>
                <Button
                  className={composeClassNames([sButton])}
                  onClick={() => push(constants.Paths.pageClasses)}
                  variant="outline-secondary"
                >
                  <Translate tKey="Series and classes" />
                </Button>
                <Button
                  className={composeClassNames([sButton])}
                  onClick={() => push(constants.Paths.pageProfiles)}
                  variant="outline-secondary"
                >
                  <Translate tKey="Inspiring instructors" />
                </Button>
                <Button
                  className={composeClassNames([sButton])}
                  onClick={() => push(constants.Paths.pageBenefits)}
                  variant="outline-secondary"
                >
                  <Translate tKey="Benefits offer" />
                </Button>
              </div>
            </Col>
          </Row>
        </Content>
        <Footer />
      </Page>
      <Footers />
    </>
  );
}
